<template>
	<div class="locked-step-by-you-container display-flex flex-column">
		<div class="display-flex flex-row flex-align-center">
			<div
				:class="{ 'is-locked-by-collaborator': isLockedByCollaborator }"
				class="locked-indication display-flex flex-row flex-align-center px-2"
			>
				<SIcon name="personal-space" width="10" height="15" />
				<h3 :class="{ 'is-locked-by-collaborator': isLockedByCollaborator }" class="reg ml-1">
					Step locked by {{ lockedCollaboratorName || 'you' }}
				</h3>
			</div>
		</div>
		<h5 class="mt-3">
			Only {{ isLockedByCollaborator ? 'connection owner' : 'you' }} can edit this step with this connection. Other collaborators can see
			this step, but can’t edit it unless they gain access to the connection or change it with another.
		</h5>
		<a class="mt-3 link" href="https://docs.ply.io" target="_blank"><h5 class="medium">Learn more</h5></a>
	</div>
</template>

<script>
export default {
	name: 'LockedStepBy',
	props: {
		lockedCollaboratorName: { type: String },
	},
	methods: {},
	computed: {
		isLockedByCollaborator() {
			return this.lockedCollaboratorName?.length > 0;
		},
	},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.locked-step-by-you-container {
	max-width: 440px;
	height: 130px;
	padding: 14px 12px;
	border-radius: 10px;
	background: var(--white);
}
.is-locked-by-collaborator {
	color: var(--white);
}
.locked-indication {
	border-radius: 5px;
	background: #c1f1ee;
	&.is-locked-by-collaborator {
		background: #727998;
		::v-deep {
			circle,
			path {
				stroke: var(--white) !important;
			}
			path,
			line {
				fill: var(--white) !important;
			}
		}
	}
}
.link {
	color: var(--primary-font-color) !important;
}
.medium {
	font-weight: medium !important;
}
</style>
